import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import EventsHeroSection from './components/EventsHeroSection';
import EventsContentSection from './components/EventsContentSection';
import EventsPriceSection from './components/EventsPriceSection';

export default function EventsAdultsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <EventsHeroSection />
        <EventsContentSection />
        <EventsPriceSection />
      </main>
      <Footer />
    </div>
  );
}